$(document).ready(function () {

    const allCategoryItems = document.querySelectorAll('.\--for-category');
    allCategoryItems.forEach(item => {
      if (item.previousElementSibling || item.nextElementSibling) {
      } else {
        item.classList.add('no-siblings');
      }
    });
    
    // Existing toggle for main nav trigger
    $(".E-main-nav-trigger").on("click", function () {
        $(this).toggleClass("--is-active");
        // Toggle aria-expanded attribute
        var isExpanded = $(this).hasClass("--is-active");
        $(this).attr("aria-expanded", isExpanded);
        $("html").toggleClass("--no-scroll");
        $("body").toggleClass("--no-scroll");
        $("#E-search-panel").removeClass("--is-active");
    });

    // Function to toggle category
    function toggleCategory($element) {
        // Close any other active categories first
        $element
            .closest("ul")
            .find("li.--is-active")
            .not($element.closest("li"))
            .removeClass("--is-active");
        // Toggle the clicked category
        $element.closest("li").toggleClass("--is-active");
    }

    //to check iphone and ipad
    
    if (/ipad|iphone|ipod|macintosh/.test(navigator.userAgent.toLowerCase()) && !window.MSStream) {
      $('body').addClass('ios-device');
    }
    // New toggle for category parent li elements
    $(".--for-category").on("click", function (e) {
        toggleCategory($(this));
        // Toggle aria-expanded attribute
        var isExpanded = $(this).closest("li").hasClass("--is-active");
        $(this).attr("aria-expanded", isExpanded);
    });

    // Add keydown event to handle Enter key
    $(".--for-category").on("keydown", function (e) {
        if (e.which === 13) { // 13 is the Enter key
            e.preventDefault();
            e.stopPropagation();
            toggleCategory($(this));
            // Toggle aria-expanded attribute
            var isExpanded = $(this).closest("li").hasClass("--is-active");
            $(this).attr("aria-expanded", isExpanded);
        }
    });

    const searchIcon = document.querySelector('.E-utilities-item');
    const searchPanel = document.querySelector('.E-search-panel');

    searchIcon.addEventListener('click', () => {
      document.body.classList.add('no-scroll');
    });

    // On panel close:
    const closeBtn = document.querySelector('.E-search-panel__close');
    closeBtn.addEventListener('click', () => {
      document.body.classList.remove('no-scroll');
    });

    // Add hover functionality
    // Only apply hover functionality for viewports wider than 1023px
    $(window).on("load resize", function() {
        if ($(window).width() > 1023) {
          $("html").removeClass("--no-scroll");
          $("body").removeClass("--no-scroll");
            // Enable hover functionality
            $(".E-main-nav-list > li > div > ul > li > *").on("mouseenter", function() {
                // Remove active class from all other category items
                $(".E-main-nav-list > li > div > ul .--for-category").closest("li").removeClass("--is-active");
                // Add active class to current category
                $(this).closest("li").addClass("--is-active");
            });

            // Remove active class when mouse leaves the dropdown area
            $(".E-main-nav-list > li > div > ul > li > div").on("mouseleave", function(e) {
                // Check if we're actually leaving the div and not just entering a child element
                if (!$(this).is(e.relatedTarget) && !$(this).has(e.relatedTarget).length) {
                    $(this).closest("li").removeClass("--is-active");
                }
            });
        } else {
            // Disable hover functionality for mobile
            $(".E-main-nav-list > li > div > ul > li > *").off("mouseenter");
            $(".E-main-nav-list > li > div > ul > li > div").off("mouseleave");
        }
    });

    // Close menu when clicking outside
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".E-main-nav").length) {
            $("li.--is-active").removeClass("--is-active");
        }
    });
    
    // When page is loaded, get url and text from first .E-utilities-item
    const firstUtilityItem = $(".E-utilities-item").first();
    const utilityUrl = firstUtilityItem.attr("href");
    const utilityText = firstUtilityItem.text().trim();

    // Create new enhanced link with the same attributes
    const enhancedLink = $("<a>")
      .addClass("E-main-nav-enhanced-link")
      .attr("href", utilityUrl)
      .text(utilityText);

    // Add the enhanced link as the last element in .E-main-nav__inner
    $(".E-main-nav__inner").append(enhancedLink);

    // Copy the aside navigation to the main navigation
    const asideNavList = $(".E-top-bar__right .E-aside-nav-list").clone(true);
    $(".E-main-nav__inner").append(asideNavList);
    
});

analytics.eventConfig.push(
  {
    target: ".E-main-nav",
    events: [
      {
        eventTarget: ".E-main-nav-list .nav-link",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "menuClick", // menuClick, searchSubmit, buttonClick
          menuType: "megaMenu",
          menuItem: "", // dynamic
          menuURL: "", // dynamic
          // menuSearch: "", // dynamic
          deviceType: "", // dynamic
          // buttonClicked: "", // dynamic
        },
      },
      {
        eventTarget: ".E-main-nav-list .--for-category",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "menuClick",
          menuType: "megaMenu",
          menuItem: "", // dynamic
          menuURL: "dropdown-menu", // dynamic
          // menuSearch: "", // dynamic
          deviceType: "", // dynamic
          // buttonClicked: "", // dynamic
        },
      },
    ],
  },
  {
    target: ".E-aside-nav-list",
    events: [
      {
        eventTarget: ".E-aside-nav-link",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "menuClick", // menuClick, searchSubmit, buttonClick
          menuType: "megaMenu",
          menuItem: "", // dynamic
          menuURL: "", // dynamic
          // menuSearch: "", // dynamic
          deviceType: "", // dynamic
          // buttonClicked: "", // dynamic
        },
      }
    ],
  },
  {
    target: ".E-identification__company",
    events: [
      {
        eventTarget: ".E-identification__link",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "menuClick", // menuClick, searchSubmit, buttonClick
          menuType: "megaMenu",
          menuItem: "", // dynamic
          menuURL: "", // dynamic
          // menuSearch: "", // dynamic
          deviceType: "", // dynamic
          // buttonClicked: "", // dynamic
        },
      }
    ],
  },
  {
    target: ".E-main-bar",
    events: [
      {
        eventTarget: ".E-utilities-item",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "buttonClick",
          menuType: "megaMenu",
          menuItem: "", // dynamic
          menuURL: "", // dynamic
          // menuSearch: "", // dynamic
          deviceType: "", // dynamic
          buttonClicked: "", // dynamic
        },
      },
    ],
  },
  {
    target: ".E-search-panel",
    events: [
      {
        eventTarget: ".E-search-form__submit",
        eventType: "click",
        tags: {
          navigationInteraction: "navigationInteraction",
          menuAction: "searchSubmit",
          // menuType: "megaMenu",
          // menuItem: "", // dynamic
          // menuURL: "", // dynamic
          menuSearch: "", // dynamic
          deviceType: "", // dynamic
          // buttonClicked: "", // dynamic
        },
      },
    ],
  }
);